import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BaseUiService } from 'projects/core/src/lib/services/base-ui.service';
import { TranslocoService } from '@ngneat/transloco';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class UiService extends BaseUiService {

  modalSpinnerVisible$ = new BehaviorSubject<boolean>(false);
  modalSpinnerMessage$ = new BehaviorSubject<string>('');

  constructor(
    protected messageService: MessageService,
    protected transloco: TranslocoService,
    protected confirmation: ConfirmationService,
    protected title: Title
  ) {
    super(messageService, transloco, confirmation, title);
  }

  showModalSpinner(message: string): void {
    this.modalSpinnerVisible$.next(true);
    this.modalSpinnerMessage$.next(message);
  }

  hideModalSpinner(): void {
    this.modalSpinnerVisible$.next(false);
    this.modalSpinnerMessage$.next('');
  }

  public showAlert(message: string, header: string = null): void {
    this.confirmation.confirm({
      message: message,
      header: header || this.transloco.translate('common.labels.info'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.transloco.translate('common.ok'),
      acceptIcon: '',
      rejectVisible: false,
      accept: () => {
      }
    });
  }

}
